import './CategoryItem.css';
import Button from '../Button/Button';
import { useHyphenate } from '../../hooks/useHyphenate';

const CategoryItem = ({ name, description, image, onAdd, onRemove, inCart }) => {
  const hasCartAction = onAdd || onRemove;
  const hyphenate = useHyphenate();

  return (
    <div className="category-item-info">
      <div className="category-item-image-stage">
        <img src={image} alt={name || 'Item'} className="category-item-image" />
      </div>
      <div className="category-item-title">{hyphenate(name)}</div>
      <div className="category-item-desc">{hyphenate(description)}</div>
      {hasCartAction && (
        <div className="category-item-cart-overlay">
          <Button
            variant="icon"
            className="category-item-cart-overlay-btn"
            onClick={(e) => {
              e.stopPropagation();
              inCart ? onRemove() : onAdd();
            }}
            aria-label={inCart ? 'Remove from cart' : 'Add to cart'}
          >
            <span className="material-symbols-outlined">
              {inCart ? 'remove_shopping_cart' : 'add_shopping_cart'}
            </span>
          </Button>
        </div>
      )}
    </div>
  );
};

export default CategoryItem;
